import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from "@angular/core";

import type { ChatRuntimeController } from './chat-runtime.controller';

@Component({
  selector: "app-chat-composer",
  templateUrl: "./chat-composer.component.html",
  host: { style: "display: contents" },
  standalone: false
})
export class ChatComposerComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) view!: ChatRuntimeController;
  @ViewChild("chatTextarea", { static: true }) chatTextarea?: ElementRef<HTMLTextAreaElement>;

  ngAfterViewInit(): void {
    this.view.state.chatTextarea = this.chatTextarea;
  }

  ngOnDestroy(): void {
    if (this.view.state.chatTextarea === this.chatTextarea) {
      this.view.state.chatTextarea = undefined;
    }
  }
}
